////////////////////////////////////////////////////////////////////////////////
//
//
// (C) Copyright 2023 Autodesk, Inc. All rights reserved.
//
//                      ****  CONFIDENTIAL MATERIAL  ****
//
// The information contained herein is confidential, proprietary to
// Autodesk, Inc., and considered a trade secret.  Use of this information
// by anyone other than authorized employees of Autodesk, Inc. is granted
// only under a written nondisclosure agreement, expressly prescribing the
// the scope and manner of such use.
//
////////////////////////////////////////////////////////////////////////////////

import React from 'react';
import { FlexFill, FlexRow, StructureTitles } from '../CommonStyledComponents';
import { Heading } from "../dataModel/Heading";
import { ConvertSummary } from "../converters/ConvertSummary";

const StructureDetailHeading = ({ item }: { item: Heading }) => {
    return (
        <FlexRow>
            <StructureTitles>{item.Title}</StructureTitles>
            <FlexFill />
            <div>{ConvertSummary.Convert(item)}</div>
        </FlexRow>
    );
};

export default StructureDetailHeading;